export const PACKAGE_NAME = 'jiraUpgradeOnboardingExperiment';
export const TEAM_NAME = 'transmuters-growth';

export const KEY_USER_PROPERTIES_MODAL_SHOWN = 'upgrade-onboarding-experiment-modal-viewed';
export const KEY_USER_PROPERTIES_DISMISS = 'upgrade-onboarding-experiment-dismiss';
export const TOUCHPOINT_NAME = 'upgrade-onboarding-experiment';

export const SEND_OPERATIONAL_EVENT = 'sendOperationalEvent';
export const SEND_UI_EVENT = 'sendUIEvent';
export const SEND_TRACK_EVENT = 'sendTrackEvent';
export const API_SUCCESS = 'success';
export const API_FAIL = 'failed';
export const API_EXPOSED = 'exposed';
export const API_CLICKED = 'clicked';
export const SUBJECT_FEATURE = 'feature';
export const SUBJECT_BUTTON = 'button';
export const SUBJECT_REFRESH_BTN = 'refreshPageButton';
export const FETCH_SITE_UPGRADED_API_CALL = 'fetchSiteUpgradedApiCall';
export const FETCH_PAYMENT_DETAILS_API_CALL = 'fetchPaymentInformation';

export const GET_USER_PROPERTY_API_CALL = 'getUserPropertyApiCall';
export const SET_USER_PROPERTY_API_CALL = 'setUserPropertyApiCall';

export const DISMISS_SPOTLIGHT_BTN = 'dismissTrialPillSpotlight';
export const SUBJECT_EXPERIMENT_ID = 'upgradeOnboardingExperiment';
